import { toast } from "sonner";
import type { ToastLevel } from "@observe-tech/mfe-shell-api";

export function createNotify() {
  return (msg: string, level: ToastLevel) => {
    switch (level) {
      case "success":
        toast.success(msg);
        return;
      case "warn":
        toast.warning(msg);
        return;
      case "error":
        toast.error(msg);
        return;
      default:
        toast(msg);
    }
  };
}
